
import { Outlet } from "react-router-dom";
import { Navigation } from "./Navigation";
import Footer from "@/components/Footer";

const SiteLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default SiteLayout;
